function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#7F7F7F;enable-background:new    ;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M12.8,16H0L2.4,0.8H48L45.6,16H32.7l-5.9,37.9H6.9L12.8,16z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M53,0.8h19.8l-2.9,18.3h11.5l2.9-18.3H104l-8.4,53.1H75.9l3-19.5H67.5l-3,19.5H44.6L53,0.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M109.1,0.8h40l-2.4,15.1h-20l-0.7,4.5h16.9l-2.1,13.5h-16.9l-0.8,4.9h20l-2.4,15.1h-40L109.1,0.8z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M351.7,0.8h40l-2.4,15.1h-20l-0.7,4.5h16.9l-2.1,13.5h-16.9l-0.8,4.9h20l-2.4,15.1h-40L351.7,0.8z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M295.8,59.3h40l-2.4,15.1h-20l-0.7,4.5h16.9l-2.1,13.5h-16.9l-0.8,4.9h20l-2.4,15.1h-40L295.8,59.3z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M154.2,0.8h21.3c14.2,0,21.3,6.5,21.4,15.9c0,13.3-8.4,21.1-23.3,21.1h-5.4l-2.5,16h-19.8L154.2,0.8z  M172.5,24.8c3.6,0,5.7-1.9,5.7-5.6c0-2.4-1.6-3.9-4.9-3.9h-1.8l-1.5,9.6h2.5V24.8z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M204.9,0.8h19.8l-6,37.9h21.5L233,53.9h-36.5L204.9,0.8z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M275.5,46.8h-15l-2.9,7h-18.8l24.7-53.1H289l7.9,53.1h-20.6L275.5,46.8z M265.9,33.6h8.4l-1.5-16.9L265.9,33.6z "
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M306.7,31.3L294.5,0.8H315l4.4,14.1l8.8-14.1h19.7l-21.3,31.5l-3.4,21.6h-19.9L306.7,31.3z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M396.8,0.8h22.5c14.8,0,21.2,6.4,21.2,15.9c0,8.5-4.4,14-10.8,16.2l8.5,21h-19.7L411.8,37h-1.1l-2.6,16.8h-19.7 L396.8,0.8z M415.8,24.6c3.3,0,5.6-1.4,5.6-5.1c0-2.6-1.6-4-4.8-4h-2.4l-1.4,9.1H415.8z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M439.4,36.7h18.5c0.1,2.5,1.3,4.5,5.6,4.5c2.9,0,4.2-0.9,4.2-2.8c0-1.5-1.6-2.3-5.5-3 c-13.9-2.4-18.6-7.1-18.6-16.3c0-11,8.2-19.1,23.1-19.1c13.7,0,21.9,5.3,21.7,17.6h-18c-0.1-2.4-1.4-3.9-4.1-3.9 c-2.3,0-3.6,0.8-3.6,2.5c0,1.6,1.5,2.4,5.5,3c12.2,2,19,6.2,19,16c0,11.7-8.1,19.5-23.9,19.7C448.1,54.9,439.2,48.9,439.4,36.7z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.4,74.4H3.6L6,59.3h45.6l-2.4,15.1H36.3l-5.9,37.9H10.5L16.4,74.4z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M56.8,59.3h22.5c14.8,0,21.2,6.4,21.2,15.9c0,8.5-4.4,14-10.8,16.2l8.5,21H78.4l-6.6-16.8h-1.1L68,112.3H48.4 L56.8,59.3z M75.7,83.1c3.3,0,5.6-1.4,5.6-5.1c0-2.6-1.6-4-4.8-4h-2.4l-1.4,9.1H75.7z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M108.4,59.3h20l-8.4,53.1h-20L108.4,59.3z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M133.4,59.3h24.7c13.4,0,17.7,6.3,17.7,13.3c0,7.1-4.8,11.4-10.5,12.5c5,1,9.2,4.5,9.2,10.9 c0,9.7-8.2,16.4-21.2,16.4H125L133.4,59.3z M150,99.6c3.3,0,5.5-2,5.5-4.9c0-2.7-1.6-3.9-4.9-3.9h-3l-1.4,8.8H150z M153.4,79.3 c3.2,0,4.7-1.5,4.7-4c0-2.4-1.5-3.3-4.2-3.3h-3.3l-1.2,7.3H153.4z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M178.5,88.5l4.7-29.2h19.7l-4.7,29.8c-0.9,5.6,0.2,8.8,5,8.8c5,0,5.8-3,6.6-8.1l4.8-30.6h19.9l-5,32.1 c-2.4,15.7-10.9,22-26.5,22C185.5,113.4,175.8,105.1,178.5,88.5z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M239.6,59.3h21.8l8,23.5l3.7-23.5h17.5l-8.4,53.1h-18.6l-10.5-27.8l-4.4,27.8h-17.6L239.6,59.3z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M512,10.3c0-5.3-4.3-9.6-9.5-9.6c-5.1,0-9.6,3.8-9.6,9.5c0,3.6,3,8.9,9.6,8.9c0,1.1-1.1,2.6-4.8,3.1l0.1,1.2 C505.4,23.5,512,17.3,512,10.3z"
});

function SvgLogoExample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 113.4",
    style: {
      enableBackground: "new 0 0 512 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExample);
export default __webpack_public_path__ + "static/media/LogoExample.e91ca1bb.svg";
export { ForwardRef as ReactComponent };